import { render, staticRenderFns } from "./geneltanitim.vue?vue&type=template&id=78b1e51b"
import script from "./geneltanitim.vue?vue&type=script&lang=js"
export * from "./geneltanitim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports